import { getOverlaySeriesKey } from '../constants';
import type { ChartRow, SessionValueMap } from '../types';

export const aggregateTrendRows = (
  perSession: SessionValueMap[],
  overlaySessionIds: number[]
): ChartRow[] => {
  if (perSession.length === 0) return [];

  const maxSecond = perSession.reduce(
    (max, entry) =>
      Math.max(max, ...Array.from(entry.values.keys(), value => value)),
    -1
  );

  if (maxSecond < 0) return [];

  return Array.from({ length: maxSecond + 1 }, (_, second) => {
    const values = perSession
      .map(entry => entry.values.get(second))
      .filter((value): value is number => typeof value === 'number');

    const mean =
      values.length > 0
        ? values.reduce((sum, value) => sum + value, 0) / values.length
        : 0;
    const std =
      values.length > 1
        ? Math.sqrt(
            values.reduce((sum, value) => sum + (value - mean) ** 2, 0) /
              (values.length - 1)
          )
        : 0;

    const row: ChartRow = {
      second,
      mean,
      stdUpper: mean + std,
      stdLower: mean - std,
    };

    overlaySessionIds.forEach(sessionId => {
      const overlayValues = perSession.find(
        entry => entry.sessionId === sessionId
      );
      row[getOverlaySeriesKey(sessionId)] =
        overlayValues?.values.get(second) ?? null;
    });

    return row;
  });
};
